// Create a new custom element for product links with images for transitions to PDP
class ProductCardLink extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick, true);
    //this.addEventListener('oat:swatch-click', this.#onSwatchClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick, true);
    //this.removeEventListener('oat:swatch-click', this.#onSwatchClick);
  }


  get productTransitionEnabled() {
    return this.getAttribute('data-product-transition') === 'true';
  }

  get featuredMediaUrl() {
    return this.getAttribute('data-featured-media-url');
  }

  /**
   * Handles the click event for the product link
   * @param {Event} event
   */
  #swatchBlockUntil = 0;

  #onSwatchClick = (e) => {
    // Block clicks for 250ms
    this.#swatchBlockUntil = performance.now() + 250;
  };

  #lastSwatchClickTime = 0;

  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const isOverlayAction =
      !!event.target.closest('[data-oat-tryon]') ||
      !!event.target.closest('[data-open-studio]') ||
      !!event.target.closest('[data-oat-wishlist]') ||
      !!event.target.closest('[data-oat-quickadd-trigger]') ||
      !!event.target.closest('quick-add-component') ||
      !!event.target.closest('.oat-tile-overlay__icon') ||
      !!event.target.closest('.oat-tryon');

    if (isOverlayAction) {
      // Let custom tile actions bubble to their own handlers.
      return;
    }

    const inSwatches = !!event.target.closest('swatches-variant-picker-component');
    if (inSwatches) {
      // Never interfere with swatch interaction.
      return;
    }

    const clickedOnMedia =
      !!event.target.closest('slideshow-component') ||
      !!event.target.closest('.product-card__media');

    const clickedOnTitle =
      !!event.target.closest('.product-card__title');

    // Block everything except media/title
    if (!clickedOnMedia && !clickedOnTitle) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    // Allow native navigation (anchor uses updated href).
    // Only set up transition metadata.
    const gallery = this.querySelector('[data-view-transition-to-main-product]');
    if (!this.productTransitionEnabled || !(gallery instanceof HTMLElement)) return;

    const activeImage =
      gallery.querySelector('slideshow-slide[aria-hidden="false"] [transitionToProduct="true"]') ||
      gallery.querySelector('[transitionToProduct="true"]:last-child');

    if (activeImage instanceof HTMLImageElement) this.#setImageSrcset(activeImage);

    gallery.setAttribute('data-view-transition-type', 'product-image-transition');
    gallery.setAttribute('data-view-transition-triggered', 'true');
  };

  /**
   * Sets the srcset for the image
   * @param {HTMLImageElement} image
   */
  #setImageSrcset(image) {
    if (!this.featuredMediaUrl) return;

    const currentImageUrl = new URL(image.currentSrc);

    // Deliberately not using origin, as it includes the protocol, which is usually skipped for featured media
    const currentImageRawUrl = currentImageUrl.host + currentImageUrl.pathname;

    if (!this.featuredMediaUrl.includes(currentImageRawUrl)) {
      const imageFade = image.animate([{ opacity: 0.8 }, { opacity: 1 }], {
        duration: 125,
        easing: 'ease-in-out',
      });

      imageFade.onfinish = () => {
        image.srcset = this.featuredMediaUrl ?? '';
      };
    }
  }
}

if (!customElements.get('product-card-link')) {
  customElements.define('product-card-link', ProductCardLink);
}
